module.exports = __webpack_public_path__ + "static/media/weejadu.6f3ee5e7.png";